import { isNil } from 'lodash'

import { CertificationEntity } from '@eastcoal/api/auth/interface'

import { pick } from '@eastcoal/common/utils/object'
import { uuid } from '@eastcoal/common/utils/uuid'

import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { DateRangePicker } from '@eastcoal/formily/components/DatePicker'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { UploadFile } from '@eastcoal/formily/components/UploadFile'

import { DictSelect } from '../../../@formily/DictSelect'
import { AuctionCode } from '../../../enums/AuctionCode'
import { useCertificationsStore } from '../Store/hooks/useStore'

import { OkButton } from './components/OkButton'
import {
  CertificationFormData,
  CertificationsModalFormExposedProps,
  CertificationsModalFormProps
} from './interface'

const schema: CertificationsModalFormProps['schema'] = [
  {
    name: 'name',
    title: '资质类型',
    type: 'string',
    required: true,
    'x-decorator': FormItem,
    'x-component': DictSelect,
    'x-component-props': {
      code: 'AUDIT_CERTIFICATION_TYPE'
    }
  },
  {
    name: 'image',
    type: 'array',
    title: '资质许可证',
    required: true,
    'x-decorator': FormItem,
    'x-component': UploadFile
  },
  {
    name: 'businessProject',
    type: 'string',
    title: '经营项目',
    required: true,
    'x-decorator': FormItem,
    'x-component': Input
  },
  {
    name: 'code',
    type: 'string',
    title: '编号或代码',
    required: true,
    'x-decorator': FormItem,
    'x-component': Input
  },
  {
    name: 'timeType',
    type: 'string',
    title: '有效期类型',
    default: '0',
    required: true,
    'x-decorator': FormItem,
    'x-component': DictSelect,
    'x-component-props': {
      showValue: false,
      code: AuctionCode.VALID_DATE_TYPE
    }
  },
  {
    name: '[beginTime,endTime]',
    type: 'array',
    title: '有效期',
    required: true,
    'x-display': '{{$values.timeType === "1" ? "hidden":"visible" }}',
    'x-decorator': FormItem,
    'x-component': DateRangePicker
  }
]

const formatFormData = (values?: CertificationFormData) => {
  return {
    ...values,
    image: values?.image?.join(),
    id: isNil(values?.id) ? `${uuid()}` : values?.id
  }
}

const formateDetail = (values?: CertificationEntity) => {
  return isNil(values)
    ? {
        name: '危险废物经营许可证'
      }
    : {
        ...values,
        image: values?.image?.split(',')
      }
}

export const CertificationsModalForm = ({
  mode
}: CertificationsModalFormExposedProps) => {
  const {
    currentCertification,
    certificationFormVisible,
    toggleCertificationFormVisible,
    setValues
  } = useCertificationsStore(state =>
    pick(state, [
      'certificationFormVisible',
      'toggleCertificationFormVisible',
      'currentCertification',
      'setValues'
    ])
  )

  const createApi: CertificationsModalFormProps['createApi'] = async values => {
    setValues([formatFormData(values)])
  }

  return (
    <CrudModalForm
      createApi={createApi}
      mode={mode}
      name='certifiationsModalForm'
      open={certificationFormVisible}
      schema={schema}
      values={formateDetail(currentCertification)}
      actions={[
        <CancelButton key='certificationCancelBtn' />,
        <OkButton key='certificationOkBtn' />
      ]}
      onOpenChange={toggleCertificationFormVisible}
    />
  )
}
